import { render, staticRenderFns } from "./RolesDetailsForm.vue?vue&type=template&id=24d62464&"
import script from "./RolesDetailsForm.vue?vue&type=script&lang=js&"
export * from "./RolesDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./RolesDetailsForm.vue?vue&type=style&index=0&id=24d62464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports